module.exports = {"TXTCLI_Preview":{"id":"TXTCLI_Preview","defaultMessage":"Preview"},"TXTCLI_Report_3":{"id":"TXTCLI_Report_3","defaultMessage":"Report"}}